import * as Sentry from "@sentry/browser";
import { Angular as AngularIntegration } from "@sentry/integrations";
import { Integrations } from '@sentry/tracing';


function beforeNavigate(context) {
    context.name = location.pathname
        .replace(/\/[a-f0-9]{32}/g, '/<hash>')
        .replace(/\/\d+/g, '/<digits>');
    return context;
}

Sentry.init({
    dsn: 'https://a36bc5d0339b4351821273f7fdfcddc2@o347629.ingest.sentry.io/6076028',
    integrations: [
        new AngularIntegration(),
        new Integrations.BrowserTracing({
            beforeNavigate: beforeNavigate,
        }),
    ],

    tracesSampleRate: 0.1,
});



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/sentry.ts